import {Component, OnInit} from '@angular/core';
import {Course} from "../../models/course.model";
import {ArchiveService} from "../../services/archive.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-archiv',
  templateUrl: './archiv.component.html',
  styleUrls: ['./archiv.component.css']
})
export class ArchivComponent implements OnInit {


  public allCourses: Course[] = [];
  public years: string[] = [];
  public selectedYear: string | null = null;


  constructor(
    private readonly archiveService: ArchiveService,
    private readonly _router: Router,
  ) {
  }

  ngOnInit(): void {
    this.scrollToTop();

    this.archiveService.archiveCourses$.subscribe(courses => {
      this.allCourses = courses;
      this.years = this.archiveService.getAvailableYears();
    });

    this.initialiseComponent();
  }

  public selectData(year: string): void {
    this.selectedYear = year;
    this._router.navigate(['programm/archiv'], {queryParams: {year}})
      .then(r =>
        localStorage.setItem('selectedYear', year)
      );
    this.archiveService.getArchivedCoursesByYear(year);
  }

  public initialiseComponent(): void {
    if (this.selectedYear) {
      this._router.navigate(['programm/archiv'], {queryParams: {year: this.selectedYear}});
      this.archiveService.getArchivedCoursesByYear(this.selectedYear);
    } else {
      this._router.navigate(['programm/archiv']);
      this.archiveService.loadAllArchivedCourses();
    }
  }

  private scrollToTop(): void {

    setTimeout(() => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }, 0);
  }


}
